/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Build_Empty_BodyInputs */

const en_us2_plan_build_empty_body = /** @type {(inputs: Plan_Build_Empty_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create Workout A and pick the exercises one by one, ask your trainer for suggestions along the way, or let the trainer build it all and just approve.`)
};

const pt_br2_plan_build_empty_body = /** @type {(inputs: Plan_Build_Empty_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crie o Treino A e escolha os exercícios um a um, peça sugestões ao personal no caminho, ou deixe ele montar tudo e só aprove.`)
};

const es_419_plan_build_empty_body = /** @type {(inputs: Plan_Build_Empty_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crea el Entrenamiento A y elige los ejercicios uno a uno, pídele sugerencias a tu entrenador en el camino, o deja que él lo arme todo y solo apruébalo.`)
};

const pt_pt2_plan_build_empty_body = /** @type {(inputs: Plan_Build_Empty_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cria o Treino A e escolhe os exercícios um a um, pede sugestões ao treinador pelo caminho, ou deixa-o montar tudo e só aprovas.`)
};

const fr_fr2_plan_build_empty_body = /** @type {(inputs: Plan_Build_Empty_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crée la séance A et choisis les exercices un par un, demande des suggestions à ton coach en chemin, ou laisse-le tout construire et valide simplement.`)
};

const de_de2_plan_build_empty_body = /** @type {(inputs: Plan_Build_Empty_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erstelle Training A und wähl die Übungen einzeln aus, frag deinen Coach unterwegs nach Vorschlägen oder lass ihn alles bauen und gib nur dein Okay.`)
};

const it_it2_plan_build_empty_body = /** @type {(inputs: Plan_Build_Empty_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crea l'Allenamento A e scegli gli esercizi uno per uno, chiedi suggerimenti al coach strada facendo, oppure lascia che il coach crei tutto e tu approvi.`)
};

/**
* | output |
* | --- |
* | "Create Workout A and pick the exercises one by one, ask your trainer for suggestions along the way, or let the trainer build it all and just approve." |
*
* @param {Plan_Build_Empty_BodyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_build_empty_body = /** @type {((inputs?: Plan_Build_Empty_BodyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Build_Empty_BodyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_build_empty_body(inputs)
	if (locale === "es-419") return es_419_plan_build_empty_body(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_build_empty_body(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_build_empty_body(inputs)
	if (locale === "de-DE") return de_de2_plan_build_empty_body(inputs)
	if (locale === "it-IT") return it_it2_plan_build_empty_body(inputs)
	return en_us2_plan_build_empty_body(inputs)
});
export { plan_build_empty_body as "plan-build.empty_body" }